import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { EncryptionService } from '../../services/encryption-info/encryption-info.service';

export const bodyEncryptionInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const encryptionService = inject(EncryptionService);

  if (encryptionService.shouldSkipEncryption(req)) {
    return next(req);
  }

  return from(encryptionService.encryptBody(req.body)).pipe(
    concatMap((requestInfo) => {
      const encryptedReq = req.clone({
        body: requestInfo.body,
        headers: req.headers
          .set('x-encryption-serial', requestInfo.serverKeySerial)
          .set('x-site-identifier', requestInfo.siteId)
          .set('x-merchant-portal-secret', 'suchsecretmuchwow'),
      });
      return next(encryptedReq);
    }),
    concatMap((event) => from(encryptionService.decryptBody(event, req))),
    catchError((error) => from(encryptionService.decryptError(error))),
  );
};
